module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmh",
    attrs: {
      "id": "toc"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/title#tit",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/copyrightnotice#notice",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright Notice")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/dedication"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/acknowledgments#ack"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/foreword#foreword"
    }
  }, [_vm._v("Foreword")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#ch1"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("ZodiacProtection and Safety Spells")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#ch1-h1"
    }
  }, [_vm._v("Heads Up")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#ch1-h2"
    }
  }, [_vm._v("Security Spell")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#ch1-h3"
    }
  }, [_vm._v("Foresight")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#ch1-h4"
    }
  }, [_vm._v("To Protect Children")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#ch1-h5"
    }
  }, [_vm._v("The Watch")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#ch1-h6"
    }
  }, [_vm._v("Germ Warfare")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#ch1-h7"
    }
  }, [_vm._v("Legal Protection")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#ch1-h8"
    }
  }, [_vm._v("Keeping Your Secrets Safe")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#ch1-h9"
    }
  }, [_vm._v("To Gain the Sight")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#ch1-h10"
    }
  }, [_vm._v("Rock of Protection")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#ch1-h11"
    }
  }, [_vm._v("Pentacle of Protection")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#ch1-h12"
    }
  }, [_vm._v("Psychic Self-Defense")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter2#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("ZodiacHealth")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter2#ch2-h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Aries")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter2#ch2-h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Taurus")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter2#ch2-h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gemini")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter2#ch2-h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cancer")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter2#ch2-h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Leo")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter2#ch2-h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Virgo")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter2#ch2-h7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Libra")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter2#ch2-h8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Scorpio")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter2#ch2-h9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sagittarius")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter2#ch2-h10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Capricorn")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter2#ch2-h11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Aquarius")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bot"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter2#ch2-h12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pisces")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter3#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("ZodiacMoney Spells")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter3#ch3-h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MarsMoney")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter3#ch3-h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CashCow")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter3#ch3-h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wealth Spray")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter3#ch3-h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MoonMoney")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter3#ch3-h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Go for the Gold")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter3#ch3-h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gnocchi Money Spell")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter3#ch3-h7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Balancing the Budget")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter3#ch3-h8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stealth and Wealth")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter3#ch3-h9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gambling Luck")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter3#ch3-h10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Old Money Spell")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter3#ch3-h11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Waterbearer Money Bath")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bot"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter3#ch3-h12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Step Into Money")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("ZodiacSuccess Spells")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#ch4-h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Leader of the Zodiac Pack")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#ch4-h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bull’s-Eye")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#ch4-h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Success Success")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#ch4-h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lunar Luck")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#ch4-h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Take Centerstage")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#ch4-h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Virginal Tactics")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#ch4-h7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Scales of Success")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#ch4-h8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Phoenix Rising")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#ch4-h9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Take Aim")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#ch4-h10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GoatGods")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#ch4-h11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plug Into Success")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bot"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#ch4-h12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fish Outta Water")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("ZodiacLove Spells")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#ch5-h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Zodiac Love Attraction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#ch5-h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Some Like It Hot")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#ch5-h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Bull of Venus")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#ch5-h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Double Your Pleasure")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#ch5-h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lunar Love")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#ch5-h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mating Rites")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#ch5-h7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("No Nunsense")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#ch5-h8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Soulmate Spell")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#ch5-h9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Scorpio Love Bites")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#ch5-h10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Scorpio Love Stings")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#ch5-h11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("La Selva")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#ch5-h12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Bringer of Bad Luck")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#ch5-h13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Cold Fish")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bot"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#ch5-h14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Glamorfish")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter6#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("7 Deadly Sins + 5")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter6#ch6-h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Wrathful Ram")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter6#ch6-h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Glutton")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter6#ch6-h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nervous Nellies")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter6#ch6-h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Pack Rat")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter6#ch6-h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Lofty Lion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter6#ch6-h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Nitpick and the Gossip")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter6#ch6-h7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Lusty Libra")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter6#ch6-h8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Green Eyed Monster")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter6#ch6-h9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Stinging Arrow")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter6#ch6-h10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Greedy Goat")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter6#ch6-h11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Emotional Arctic Zone")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter6#ch6-h12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Lazy Fish")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bot"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter6#ch6-h13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Addiction: The 4 types")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter7#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Specialty of the House")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter7#ch7-h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("My Favorite Martian")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter7#ch7-h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Sensual Bull")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter7#ch7-h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Wonderful Wit")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter7#ch7-h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("There’s No Place Like Home")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter7#ch7-h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Shining Star")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter7#ch7-h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spell to Clean Up a Mess")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter7#ch7-h7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Karmic Scales")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter7#ch7-h8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tower Magic")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter7#ch7-h9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spell for Adventure")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter7#ch7-h10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Jack Benny Spell")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter7#ch7-h11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Friendship and Freedom Spells")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter7#ch7-h12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psychic Power Spell")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bot"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter7#ch7-h13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Final Specialty Spell")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/afterword#after",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Afterword")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/note#note",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/adcard#adc",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Also by Lexa Roséan")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/copyright#crt",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2176abdc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 66
// module chunks = 0